import { Link } from '@backstage/core-components';
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import { ComponentVersionTag } from '@internal/backstage-plugin-bidone-backend';
import React from 'react';
import { styled } from '@mui/material/styles';

interface TagsListProps {
  tags?: Record<string, ComponentVersionTag>
}

interface TagStyleProps {
  position?: 'top' | 'bottom';
  isDeployed?: boolean;
  tagMatched?: boolean;
}

const pillRadius = 8;
const dangerColor = '#f44336';
const successColor = '#4caf50';
const inactiveColor = '#ccc';

const getPillColor = (isDeployed?: boolean, tagMatched?: boolean) => {
  if (isDeployed) {
    return tagMatched ? successColor : dangerColor;
  }
  return inactiveColor;
}

const TagContainer = styled('div')(({ isDeployed, tagMatched }: TagStyleProps) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  border: '1px solid',
  borderColor: getPillColor(isDeployed, tagMatched),
  borderRadius: pillRadius,
  marginRight: 8,
  marginBottom: 8,
}))

const TagPart = styled('div')(({ position, tagMatched, isDeployed }: TagStyleProps) => ({
  borderBottom: position === 'top' ? '1px solid' : 'none',
  borderColor: getPillColor(isDeployed, tagMatched),
  borderTopRightRadius: position === 'top' ? pillRadius : 0,
  borderTopLeftRadius: position === 'top' ? pillRadius : 0,
  borderBottomRightRadius: position === 'bottom' ? pillRadius : 0,
  borderBottomLeftRadius: position === 'bottom' ? pillRadius : 0,
  padding: '2px 6px',
  textAlign: 'center',
  width: '90px',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  fontWeight: position === 'top' ? 600 : 400,
  backgroundColor: position === 'top' ? getPillColor(isDeployed, tagMatched) : 'transparent',
  color: position === 'top' ? '#fff' : 'inherit',
}))

export const EnvTagsListComponent: React.FC<TagsListProps> = ({ tags }: TagsListProps) => {
  return (
    tags &&
    <Grid container>
      {Object.entries(tags).map(([env, { azureLink, azureTag, isDeployed, tagMatched }]) =>
        <Grid key={env}>
          <TagContainer isDeployed={isDeployed} tagMatched={tagMatched}>
            <TagPart position="top" tagMatched={tagMatched} isDeployed={isDeployed}>{env}</TagPart>
            <TagPart>
              {
                isDeployed &&
                <Tooltip title={azureTag} placement='top'>
                  <Link to={azureLink || '#'}>{azureTag}</Link>
                </Tooltip>
              }
              {!isDeployed && <span>-</span>}
            </TagPart>
          </TagContainer>
        </Grid>
      )}
    </Grid>
  )
}
